<template>
  <div class="index_info">
    <div class="col">
      <el-button @click="allSelArea" size="small" type="primary">全选</el-button>
      <el-button @click="clearSelArea" size="small" type="danger">清除</el-button>
    </div>
    <el-tree ref="setTreeArea" :data="areaTreeList" show-checkbox node-key="Id" :default-checked-keys="checkedArea"
      :props="defaultProps" :accordion="true" @check="handleCheckedArea"></el-tree>
    <div class="dialog-footer">
      <el-button type="primary" @click="areaSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import {
  GetAreaTree,
  KSAXApiRequest
} from "../../../api/api";
import { areaData } from "./areaData.js"; // 组件数据
export default {
  props: ["id", "areaStr"],
  data() {
    return {
      areaTreeList: [],
      isRefresh: true,
      defaultProps: {
        children: "SubAreas",
        label: "AreaName",
      },
      areaList: [],
      checkedArea: [],
      listStr: "",
    };
  },
  created() {
    this.areaTreeList = areaData;
    if (this.areaStr) {
      this.checkedArea = this.areaStr.split(",").map((v) => {
        return parseInt(v);
      });
      console.log(this.checkedArea);
    }
    this.getProvinceList();
  },
  methods: {
    getProvinceList() {
      let that = this;
      GetAreaTree({
        MaxLevel: 1
      }).then((res) => {
        let areaList = [];
        res.data.result.children.forEach((v, i) => {
          areaList.push(v.data.Id)
        });
        that.areaList = areaList;
      });
    },
    allSelArea() {
      if (this.checkedArea.length != 31) {
        this.checkedArea = [];
        this.checkedArea = this.areaList;
        this.$refs.setTreeArea.setCheckedNodes(this.checkedArea);
      }
    },
    clearSelArea() {
      this.checkedArea = [];
      this.listStr = "";
      this.$refs.setTreeArea.setCheckedNodes(this.checkedArea);
    },
    handleCheckedArea(data, val) {
      console.log(data, val);
      if (data.Level == 1 && !val.halfCheckedKeys[0]) {
        if (this.checkedArea.indexOf(data.Id) == -1) {
          if (data.SubAreas.length > 1) {
            data.SubAreas.forEach((v) => {
              if (this.checkedArea.indexOf(v.Id) != -1) {
                this.checkedArea.splice(this.checkedArea.indexOf(v.Id), 1);
              }
            });
          } else {
            data.SubAreas[0].SubAreas.forEach((v) => {
              if (this.checkedArea.indexOf(v.Id) != -1) {
                this.checkedArea.splice(this.checkedArea.indexOf(v.Id), 1);
              }
            });
          }
          this.checkedArea.push(data.Id);
        } else {
          data.SubAreas.forEach((v) => {
            if (this.checkedArea.indexOf(v.Id) != -1) {
              this.checkedArea.splice(this.checkedArea.indexOf(v.Id), 1);
            }
          });
          this.checkedArea.splice(this.checkedArea.indexOf(data.Id), 1);
        }
      } else if (data.Level == 2 && val.halfCheckedKeys[0]) {
        var index = val.halfCheckedKeys.indexOf(data.ParentId);
        console.log(index);
        // 父级id不存在时
        if (
          this.checkedArea.indexOf(data.ParentId) == -1 &&
          val.halfCheckedKeys.indexOf(data.ParentId) != -1
        ) {
          if (this.checkedArea.indexOf(data.Id) == -1) {
            this.checkedArea.push(data.Id);
          } else {
            this.checkedArea.splice(this.checkedArea.indexOf(data.Id), 1);
          }
          // console.log('val.halfCheckedKeys1',this.checkedArea);
        } else if (
          this.checkedArea.indexOf(data.ParentId) == -1 &&
          val.halfCheckedKeys.indexOf(data.ParentId) == -1
        ) {
          this.checkedArea.push(data.Id)
          // if (this.checkedArea.indexOf(data.ParentId) == -1) {
          //   this.checkedArea.push(data.ParentId);
          // } else {
          //   this.checkedArea.splice(this.checkedArea.indexOf(data.ParentId), 1);
          // }
          // console.log('val.halfCheckedKeys2',this.checkedArea);
        } else {
          // 父级id存在时
          if (this.checkedArea.indexOf(data.Id) == -1) {
            val.halfCheckedNodes[index].SubAreas.forEach((v) => {
              if (v.Id != data.Id && this.checkedArea.indexOf(v.Id) == -1) {
                this.checkedArea.push(v.Id);
              }
            });
            this.checkedArea.splice(this.checkedArea.indexOf(data.ParentId), 1);
          }
          // console.log('val.halfCheckedKeys3',this.checkedArea);
        }
      } else if (data.Level == 2 && !val.halfCheckedKeys[0]) {
        // 父级id不存在时
        this.checkedArea.push(data.Id);
        data.SubAreas.forEach((v) => {
          if (this.checkedArea.indexOf(v.Id) != -1) {
            this.checkedArea.splice(this.checkedArea.indexOf(v.Id), 1);
          }
        });
        // if (this.checkedArea.indexOf(data.ParentId) == -1) {
        //   this.checkedArea.push(data.ParentId);
        // } else {
        //   this.checkedArea.splice(this.checkedArea.indexOf(data.ParentId), 1);
        // }
        // console.log('!val.halfCheckedKeys',this.checkedArea);
      } else {
        var index = val.halfCheckedKeys.indexOf(data.ParentId);
        console.log(index);
        //父级父级不存在
        if (this.checkedArea.indexOf(val.halfCheckedKeys[index - 1]) == -1) {
          //父级是否存在
          if (this.checkedArea.indexOf(val.halfCheckedKeys[index]) == -1) {
            if (this.checkedArea.indexOf(data.Id) == -1) {
              this.checkedArea.push(data.Id);
            } else {
              this.checkedArea.splice(this.checkedArea.indexOf(data.Id), 1);
            }
          } else {
            if (this.checkedArea.indexOf(data.Id) == -1) {
              val.halfCheckedNodes[index].SubAreas.forEach((v) => {
                if (v.Id != data.Id && this.checkedArea.indexOf(v.Id) == -1) {
                  this.checkedArea.push(v.Id);
                }
              });
              this.checkedArea.splice(
                this.checkedArea.indexOf(data.ParentId),
                1
              );
            }
          }
        } else {
          //父级存在
          //父级是否存在
          if (this.checkedArea.indexOf(val.halfCheckedKeys[index]) == -1) {
            val.halfCheckedNodes[index - 1].SubAreas.forEach((v) => {
              if (
                v.Id != val.halfCheckedKeys[val.halfCheckedKeys.length - 1] &&
                this.checkedArea.indexOf(v.Id) == -1
              ) {
                this.checkedArea.push(v.Id);
              }
            });
            if (this.checkedArea.indexOf(data.Id) == -1) {
              val.halfCheckedNodes[index].SubAreas.forEach((v) => {
                if (v.Id != data.Id && this.checkedArea.indexOf(v.Id) == -1) {
                  this.checkedArea.push(v.Id);
                }
              });
              this.checkedArea.splice(
                this.checkedArea.indexOf(val.halfCheckedKeys[index - 1]),
                1
              );
            } else {
              this.checkedArea.splice(this.checkedArea.indexOf(data.Id), 1);
            }
          } else {
            if (this.checkedArea.indexOf(data.Id) == -1) {
              val.halfCheckedNodes[index].SubAreas.forEach((v) => {
                if (v.Id != data.Id && this.checkedArea.indexOf(v.Id) == -1) {
                  this.checkedArea.push(v.Id);
                }
              });
              this.checkedArea.splice(
                this.checkedArea.indexOf(data.ParentId),
                1
              );
              this.checkedArea.splice(
                this.checkedArea.indexOf(val.halfCheckedKeys[index - 1]),
                1
              );
            }
          }
        }
      }
      this.listStr = this.checkedArea.join(",");
    },
    areaSubmit() {
      if (!this.listStr && !this.checkedArea[0])
        return this.$message.error("请选择地区");
      KSAXApiRequest({
        path: 'Product_MultistageStock/UpdateDeliverArea',
        parmsJson: {
          id: this.id,
          deliverArea: this.listStr ? this.listStr : this.checkedArea.join(","),
        }
      }).then(res => {
        if (res.data.success) {
          this.$message.success(res.data.msg);
          this.$parent.$parent.areaVisible = false;
          this.$parent.$parent.queryData();
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  padding: 20px;
  display: flex;
  justify-content: flex-end;
}

.col {
  padding: 0 0 20px 20px;
}
</style>